import React from "react";
import "./About.css";



import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";

import {
 
  FaBullseye,
  FaCertificate,
  FaEye,
  FaGem,
  FaGraduationCap,
  FaHandsHelping,
  FaRupeeSign,
  FaShieldAlt,
  FaUsers,
  
} from "react-icons/fa";

import certificate1 from "../../assets/images/certificate1.png";
import certificate2 from "../../assets/images/certificate2.png";
import certificate3 from "../../assets/images/certificate3.png";

function About() {


  /* =========================================================
     JOIN / REGISTER
  ========================================================= */

  

  return (
    <div className="about-page">

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <Navbar />


      {/* =====================================================
          HERO SECTION
      ===================================================== */}

      <section className="about-hero">

        <div className="about-hero-circle about-circle-one"></div>

        <div className="about-hero-circle about-circle-two"></div>


        <div className="about-hero-container">

          {/* ================= LEFT ================= */}

          <div className="about-hero-content">

            <span className="about-small-label">
              ABOUT OUR TRUST
            </span>

            <h1>
              Together, We Build
              <br />
              <span>A Stronger Community.</span>
            </h1>

            <p>
              ABNB Seva Samiti &amp; Vidya Charitable Trust is
              committed to supporting families through education,
              social welfare and financial security.
            </p>


            {/* BUTTONS */}

            

          </div>


          {/* ================= RIGHT ================= */}

          <div className="about-hero-visual">

            


            {/* FLOATING EDUCATION CARD */}

            


            {/* FLOATING WELFARE CARD */}

            

          </div>

        </div>

      </section>


      {/* =====================================================
          ABOUT TRUST / INTRODUCTION
      ===================================================== */}

      <section className="about-intro">

        <div className="about-container">

          <div className="about-intro-grid">

            {/* ================= LEFT ================= */}

            <div className="about-intro-content">

              <span className="section-label">
                WHO WE ARE
              </span>

              <h2>
                Building a
                <strong> Better Future </strong>
                Together
              </h2>

              <p>
                ABNB Seva Samiti &amp; Vidya Charitable Trust
                works towards creating a strong and supportive
                community through education, social welfare and
                financial assistance.
              </p>

              <p>
                Our goal is to ensure that families receive the
                support they need while creating opportunities
                for children, students and communities to grow.
              </p>


              

            </div>


            

          </div>

        </div>

      </section>


      {/* =====================================================
          MISSION / VISION / VALUES
      ===================================================== */}

      <section className="mission-section">

        <div className="about-container">

          <div className="section-heading">

            <span className="section-label">
              OUR FOUNDATION
            </span>

            <h2>
              Mission, Vision
              <strong> &amp; Values</strong>
            </h2>

            <p>
              Everything we do is guided by our commitment
              to families, education and community development.
            </p>

          </div>


          <div className="mission-grid">

            {/* ================= MISSION ================= */}

            <div className="foundation-card foundation-blue">

              <div className="foundation-number">
                01
              </div>

              <div className="foundation-icon">
                <FaBullseye />
              </div>

              <h3>
                Our Mission
              </h3>

              <p>
                To uplift the community through education,
                welfare activities and financial support while
                creating opportunities for a secure future.
              </p>

            </div>


            {/* ================= VISION ================= */}

            <div className="foundation-card foundation-purple">

              <div className="foundation-number">
                02
              </div>

              <div className="foundation-icon">
                <FaEye />
              </div>

              <h3>
                Our Vision
              </h3>

              <p>
                To create a caring, united and empowered
                community where every family can achieve
                security, dignity and progress.
              </p>

            </div>


            {/* ================= VALUES ================= */}

            <div className="foundation-card foundation-green">

              <div className="foundation-number">
                03
              </div>

              <div className="foundation-icon">
                <FaGem />
              </div>

              <h3>
                Our Values
              </h3>


              <div className="values-list">

                <span>
                  ✓ Service to Humanity
                </span>

                <span>
                  ✓ Empowerment
                </span>

                <span>
                  ✓ Transparency
                </span>

                <span>
                  ✓ Compassion
                </span>

                <span>
                  ✓ Trust &amp; Integrity
                </span>

                <span>
                  ✓ Commitment
                </span>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          CORE OBJECTIVES
      ===================================================== */}

      <section className="objectives-section">

        <div className="about-container">

          <div className="section-heading">

            <span className="section-label">
              WHAT WE DO
            </span>

            <h2>
              Our Core
              <strong> Objectives</strong>
            </h2>

            <p>
              Our programs focus on creating meaningful,
              long-term support for families and communities.
            </p>

          </div>


          <div className="objectives-grid">

            {/* ================= OBJECTIVE 01 ================= */}

            <div className="objective-card">

              <div className="objective-icon blue">
                <FaGraduationCap />
              </div>

              <h3>
                Quality Education
              </h3>

              <p>
                Provide educational support and opportunities
                for deserving students.
              </p>

            </div>


            {/* ================= OBJECTIVE 02 ================= */}

            <div className="objective-card">

              <div className="objective-icon yellow">
                <FaHandsHelping />
              </div>

              <h3>
                Social Welfare
              </h3>

              <p>
                Support families and communities through
                welfare and assistance programs.
              </p>

            </div>


            {/* ================= OBJECTIVE 03 ================= */}

            <div className="objective-card">

              <div className="objective-icon green">
                <FaRupeeSign />
              </div>

              <h3>
                Financial Assistance
              </h3>

              <p>
                Provide financial assistance to help families
                during important circumstances.
              </p>

            </div>


            {/* ================= OBJECTIVE 04 ================= */}

            <div className="objective-card">

              <div className="objective-icon red">
                <FaShieldAlt />
              </div>

              <h3>
                Family Security
              </h3>

              <p>
                Help members create greater financial security
                and stability for their families.
              </p>

            </div>


            {/* ================= OBJECTIVE 05 ================= */}

            <div className="objective-card">

              <div className="objective-icon purple">
                <FaUsers />
              </div>

              <h3>
                Community Growth
              </h3>

              <p>
                Build a united and supportive community that
                grows together.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          CERTIFICATES & REGISTRATIONS
      ===================================================== */}

      <section className="certificates-section">

        <div className="about-container">

          <div className="certificate-header">

            <div>

              <span className="section-label">
                TRUST &amp; COMPLIANCE
              </span>

              <h2>
                Certificates &
                <strong> Registrations</strong>
              </h2>

              <p>
                Our organization maintains the necessary
                registrations and certifications for transparent
                and responsible operations.
              </p>

            </div>


            <div className="certificate-header-icon">
              <FaCertificate />
            </div>

          </div>


          <div className="certificate-grid">

            {/* ================= 12A ================= */}

            <div className="certificate-card">

              <div className="certificate-image">

                <img
                  src={certificate1}
                  alt="12A Certificate"
                />

              </div>

              <div className="certificate-info">

                <span>
                  12A
                </span>

                <h3>
                  12A Certificate
                </h3>

                <p>
                  View Certificate
                </p>

              </div>

            </div>


            {/* ================= 80G ================= */}

            <div className="certificate-card">

              <div className="certificate-image">

                <img
                  src={certificate2}
                  alt="80G Certificate"
                />

              </div>

              <div className="certificate-info">

                <span>
                  80G
                </span>

                <h3>
                  80G Certificate
                </h3>

                <p>
                  View Certificate
                </p>

              </div>

            </div>


            {/* ================= TRUST ================= */}

            <div className="certificate-card">

              <div className="certificate-image">

                <img
                  src={certificate3}
                  alt="Trust Registration Certificate"
                />

              </div>

              <div className="certificate-info">

                <span>
                  TRUST
                </span>

                <h3>
                  Trust Registration
                </h3>

                <p>
                  View Certificate
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          CALL TO ACTION
      ===================================================== */}

      


      {/* =====================================================
          FOOTER
      ===================================================== */}

      <Footer />

    </div>
  );
}

export default About;